// extracted by mini-css-extract-plugin
export var calendarView = "_kc-0";